import { render } from "./ProductUsers.vue?vue&type=template&id=23970bd8&scoped=true&ts=true"
import script from "./ProductUsers.vue?vue&type=script&lang=ts"
export * from "./ProductUsers.vue?vue&type=script&lang=ts"

import "./ProductUsers.vue?vue&type=style&index=0&id=23970bd8&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23970bd8"]])

export default __exports__